import { useParams, useSearchParams } from "react-router-dom";
import { STILLS } from "@/stills";

export default function RenderPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const s = STILLS[id];
  if (!s) return <div data-testid="render-not-found">Unknown still</div>;
  const { Component } = s;
  return (
    <div className="render-root" data-testid="render-root">
      <Component spaStyle={params.get("style") || "warm"} />
    </div>
  );
}
